// src/api/ApiGetPrice.js

const ApiGetPrice = async (layoutKey, params, layoutApiLayoutCode) => {
  try {
    const cabinetBoxMaterialId = process.env.REACT_APP_CABINET_BOX_MATERIAL_ID;
    const drawerBoxTypeId = process.env.REACT_APP_DRAWER_BOX_TYPE_ID;
    const formData = new FormData();
    const isPanelReady = params?.appliance?.name?.trim().toLowerCase() === 'panel ready';
    formData.append('panel_ready', isPanelReady ? 'true' : 'false');

    if (params.base) {
      formData.append('base[collection_id]', params.base.collection_id);
      formData.append('base[color_id]', params.base.color_id);
      formData.append('base[doorstyleandgrain_id]', params.base.doorstyleandgrain_id);
      formData.append('base[cabinetboxmaterial_id]', cabinetBoxMaterialId);
      formData.append('base[drawerboxtype_id]', drawerBoxTypeId);
    }

    if (params.wall) {
      formData.append('wall[collection_id]', params.wall.collection_id);
      formData.append('wall[color_id]', params.wall.color_id);
      formData.append('wall[doorstyleandgrain_id]', params.wall.doorstyleandgrain_id);
      formData.append('wall[cabinetboxmaterial_id]', cabinetBoxMaterialId);
      formData.append('wall[drawerboxtype_id]', drawerBoxTypeId);
    }

    if (params.tall) {
      formData.append('tall[collection_id]', params.tall.collection_id);
      formData.append('tall[color_id]', params.tall.color_id);
      formData.append('tall[doorstyleandgrain_id]', params.tall.doorstyleandgrain_id);
      formData.append('tall[cabinetboxmaterial_id]', cabinetBoxMaterialId);
      formData.append('tall[drawerboxtype_id]', drawerBoxTypeId);
    }

    if (params.island) {
      formData.append('island[collection_id]', params.island.collection_id);
      formData.append('island[color_id]', params.island.color_id);
      formData.append('island[doorstyleandgrain_id]', params.island.doorstyleandgrain_id);
      formData.append('island[cabinetboxmaterial_id]', cabinetBoxMaterialId);
      formData.append('island[drawerboxtype_id]', drawerBoxTypeId);
    }

    if (params.vanity) {
      formData.append('vanity[collection_id]', params.vanity.collection_id);
      formData.append('vanity[color_id]', params.vanity.color_id);
      formData.append('vanity[doorstyleandgrain_id]', params.vanity.doorstyleandgrain_id);
      formData.append('vanity[cabinetboxmaterial_id]', cabinetBoxMaterialId);
      formData.append('vanity[drawerboxtype_id]', drawerBoxTypeId);
    }

    const response = await fetch(
      `https://customcabinetry-middleware.herokuapp.com/api/visualizerlayout/${layoutApiLayoutCode}/price`,
      {
        method: 'POST',
        body: formData,
      }
    );

    const data = await response.json();
    return data;

  } catch (err) {
    console.error('ApiGetPrice internal error:', err);
    throw err;
  }
};

export { ApiGetPrice };